var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    { attrs: { disabled: _vm.disabled, title: _vm.title } },
    [
      _c("r-currency-table", {
        attrs: { items: _vm.value.currencies, title: "Currency" },
        on: {
          "update:items": function ($event) {
            return _vm.$set(_vm.value, "currencies", $event)
          },
        },
      }),
      _c("v-divider"),
      _vm.ticket
        ? _c("r-ticket-table", {
            staticClass: "pt-4",
            attrs: { items: _vm.value.tickets, title: "Ticket" },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value, "tickets", $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }